"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLParamElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLParamElementImpl
};
